import { render, staticRenderFns } from "./BarChart2.vue?vue&type=template&id=32e7988a"
import script from "../../../scripts/partials/dashboard-charts/BarChart2.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/BarChart2.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports